import { FC, useState } from "react";
import Button from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";
import useInbox from "hooks/useInbox.ts";
import { useModal } from "contexts/modalContext/modalContext";
import { useToasts } from "react-toast-notifications";
import parse from "html-react-parser";
import { selectTParam } from "../../../../store/selectors/inboxSelectors";
import { useAppSelector } from "../../../../store/hooks";

type LabelT = {
  id: string;
  name: string;
  color: string;
};
interface DeleteLabelI {
  labelItem: LabelT;
  labeledMailsCount: number;
}

const DeleteLabel: FC<DeleteLabelI> = (props) => {
  const { labelItem, labeledMailsCount } = props;
  const pageType = useAppSelector(selectTParam);
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();
  const { deleteLabel, fetchMailsCount } = useInbox();
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await deleteLabel(+labelItem.id);
      await fetchMailsCount();
    } catch (err: any) {
      console.log(err);
      setLoading(false);
      addToast(getTextByKey(err?.message), {
        appearance: "error",
      });
      closeModal();
      return;
    }
    addToast(getTextByKey("toast-label-deleted"), {
      appearance: "success",
    });

    setLoading(false);
    closeModal();
  };

  return (
    <div className="remove-label-popup-wrapper">
      <h1>
        {!labeledMailsCount
          ? parse(
              getTextByKey("remove-label-confirmation-text")?.replace(
                "#name#",
                labelItem.name
              )
            )
          : parse(
              getTextByKey("remove-label-confirmation-text-with-count")
                ?.replace("#name#", labelItem.name)
                .replace("#count#", labeledMailsCount)
            )}
      </h1>
      <div className="buttons">
        <Button title={""} buttonClass={""} gray onClick={closeModal}>
          {getTextByKey("cancel")}
        </Button>
        <Button
          title={""}
          buttonClass={""}
          onClick={handleDelete}
          disabled={loading}
        >
          {getTextByKey("delete")}
        </Button>
      </div>
    </div>
  );
};

export default DeleteLabel;
